"use client";
import { useEffect, useState } from "react";
import Image from "next/image";
import { Modal, message, Typography, Button } from "antd";
import { setCookie } from "cookies-next";
import "./discount.css";
import { subscribeEmail } from "@/lib/api/subscribe";
import { useTranslations } from "next-intl";

export default function Discount() {
	const [isVisible, setIsVisible] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [email, setEmail] = useState("");
	const [showCoupon, setShowCoupon] = useState(false);
	const couponCode = "6701e208-e3fa-4603-9f7b-3f236e2ff098";
	const t = useTranslations();

	useEffect(() => {
		// 检查本地存储中是否有记录用户关闭过弹窗
		const hasClosedDiscount = localStorage.getItem("hasClosedDiscount");

		if (!hasClosedDiscount) {
			// 如果没有关闭记录，显示弹窗
			setIsVisible(true);
		}
	}, []);

	const handleClose = () => {
		setIsVisible(false);
		// 在本地存储中记录用户已关闭弹窗
		localStorage.setItem("hasClosedDiscount", "true");
	};

	// 邮箱订阅逻辑
	const handleSubscribe = async () => {
		try {
			if (!email) return;
			setIsLoading(true);
			const response = await subscribeEmail({ email: email, subscribe_type: 3 });
			if (response && response.code === 200) {
				message.success(t("message.subscribeSuccess"));
				setShowCoupon(true); // 显示优惠码弹窗
			} else {
				message.success(t("message.subscribeSuccess"));
				handleClose(); // 订阅成功后关闭弹窗
			}
		} catch (e) {
			message.error(e.message);
		} finally {
			setIsLoading(false);
		}
	};

	// 复制优惠码到剪贴板
	const copyToClipboard = () => {
		navigator.clipboard
			.writeText(couponCode)
			.then(() => {
				message.success("Coupon code copied to clipboard");
			})
			.catch(() => {
				message.error("Copy failed, please copy manually");
			});
	};

	// 处理优惠码弹窗关闭
	const handleCouponClose = () => {
		setShowCoupon(false);
		handleClose(); // 同时关闭主弹窗
	};

	return (
		<>
			<Modal
				open={isVisible}
				onCancel={handleClose}
				footer={null}
				centered
				width={460}
				closable={true}
				className="discount-modal"
				maskClosable={false}
				bodyStyle={{ padding: 0 }}
			>
				<div
					className="flex flex-col items-center"
					style={{
						backgroundImage: "url('/image/pop/bg.webp')",
						backgroundSize: "cover",
						backgroundPosition: "center",
						borderRadius: "8px",
						padding: "40px 30px 50px",
						position: "relative",
					}}
				>
					{/* 顶部折扣信息 */}
					<div className="mb-4 flex gap-4 text-center">
						<img src="/image/pop/10.png" className="w-[250px]" alt="" />
					</div>

					{/* STARY logo */}
					<div className="relative mb-8 w-full">
						{/* 使用绝对定位使logo脱离标准流 */}
						<div className="absolute left-[30%] top-10 z-10 -translate-x-1/2 -translate-y-1/2 transform">
							<Image src="/image/pop/logo.png" alt="STARY" width={200} height={100} />
						</div>

						{/* 文字部分，为logo留出空间 */}
						<div className="flex flex-col  pl-[200px] pt-8">
							<p className="mb-0 text-[24px] text-xl font-medium underline">Instant</p>
							<p className="text-[18px] text-sm">Discount on Subscribe</p>
						</div>
					</div>

					{/* 表单 */}
					<div className="w-full max-w-md">
						<div className="flex flex-col gap-3">
							<input
								type="email"
								placeholder="Email"
								className="w-full rounded-full border border-gray-300 bg-white px-4 py-3"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
							/>
							<button
								className="mt-2 w-full rounded-full bg-black py-3 font-medium text-white"
								onClick={handleSubscribe}
								disabled={isLoading}
							>
								{isLoading ? "Loading.." : "Subscribe"}
							</button>
						</div>
					</div>
				</div>
			</Modal>

			{/* 优惠码弹窗 */}
			<Modal
				open={showCoupon}
				onCancel={handleCouponClose}
				footer={null}
				centered
				width={400}
				closable={true}
				maskClosable={false}
				styles={{
					body: {
						padding: "30px",
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						background: "linear-gradient(to bottom, #f8f8f8, #ffffff)",
					},
				}}
			>
				<div className="flex flex-col items-center text-center">
					<Image src="/image/pop/logo.png" alt="STARY" width={150} height={75} className="mb-4" />
					<Typography.Title level={4} style={{ marginBottom: "20px", color: "#333" }}>
						Thank You For Subscribing!
					</Typography.Title>
					<Typography.Paragraph style={{ fontSize: "16px", marginBottom: "20px" }}>
						Your Exclusive Discount Code:
					</Typography.Paragraph>
					<div
						style={{
							padding: "12px 20px",
							background: "#f4f4f4",
							border: "1px dashed #ccc",
							borderRadius: "8px",
							marginBottom: "20px",
							width: "100%",
							wordBreak: "break-all",
							fontFamily: "monospace",
							fontSize: "14px",
						}}
					>
						{couponCode}
					</div>
					<Button
						type="primary"
						onClick={copyToClipboard}
						style={{
							width: "100%",
							height: "40px",
							backgroundColor: "#000",
							borderRadius: "20px",
						}}
					>
						Copy Code
					</Button>
				</div>
			</Modal>
		</>
	);
}
